export enum walletExportSelectType {
  CurrentWallet = 1,
  AllWallet = 2,
}

export enum ReportType {
  Wallet_Balance = 54,
  Settled_Settlement = 55,
  Transaction = 56,
  Store_Opening_Hours = 62,
}

export enum ReportTypeVn {
  WALLET_BALANCE_REPORT = 2,
  WALLET_SETTLEMENT_REPORT = 3,
  WALLET_TRANSACTION_REPORT = 4,
}

export enum REPORT_STATUS { // BE 状态
  Created = 1,
  Running = 2,
  Succeeded = 3,
  Failed = 4,
  Cancelled = 5,
}

export enum REPORT_STATUS_VN { // VN BE 状态
  Pending = 1,
  Processing = 2,
  Failed = 3,
  Success = 4,
}

export enum ReportStatus { // 前端状态
  Processing = 1,
  Success = 2,
  Fail = 3,
}

export function mapReportStatusVN(status: REPORT_STATUS_VN): REPORT_STATUS {
  switch (status) {
    case REPORT_STATUS_VN.Pending:
      return REPORT_STATUS.Created
    case REPORT_STATUS_VN.Processing:
      return REPORT_STATUS.Running
    case REPORT_STATUS_VN.Success:
      return REPORT_STATUS.Succeeded
    case REPORT_STATUS_VN.Failed:
      return REPORT_STATUS.Failed
  }
}

export function mapReportStatus(status: REPORT_STATUS): ReportStatus {
  switch (status) {
    case REPORT_STATUS.Created:
    case REPORT_STATUS.Running:
      return ReportStatus.Processing
    case REPORT_STATUS.Succeeded:
      return ReportStatus.Success
    case REPORT_STATUS.Failed:
    case REPORT_STATUS.Cancelled:
      return ReportStatus.Fail
  }
}

export interface ReportInfoID {
  // 对应 BE
  taskId: number
  taskStatus: REPORT_STATUS
  taskName: string
  fileUrl: string
  fileName: string
}

export interface ReportInfo {
  taskId: number
  taskStatus: ReportStatus
  taskName: string
  fileUrl: string
  fileName: string
  // onDownloadDone: () => void
}
